import { getIdToken } from '../hooks/useAuth.js';

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

/**
 * Authenticated fetch wrapper for the Clawdius HTTP API.
 * Attaches the Cognito ID token as a Bearer token.
 */
export async function apiFetch(path, options = {}) {
  const token = await getIdToken();
  const headers = {
    'content-type': 'application/json',
    ...(token ? { authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers,
  });

  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { data = { message: text }; }

  if (!res.ok) {
    const msg = data?.error || data?.message || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}
